import { type ethers } from "ethers";

import { getApproveCalldata, getFrontDPContract } from "../contract";
import { env } from "~/env";
import { type AaHandler } from "./aaHandler";
import { getConfigValue } from "../configs";

export const sendUserOperationWithApprove = async (
  AaHandler: AaHandler,
  to: string[],
  data: ethers.BytesLike[],
) => {
  const contract = getFrontDPContract();
  const aaTokenFee = getConfigValue("aaTokenFee") ?? 50;

  const approveCallData = getApproveCalldata(
    contract,
    env.NEXT_PUBLIC_PAY_MASTER_ADDRESS,
    aaTokenFee,
  );
  const transactionHash = await AaHandler.sendUserOperation(
    [env.NEXT_PUBLIC_DP_TOKEN_ADDRESS].concat(to),
    [approveCallData].concat(data.map((i) => i.toString())),
  );

  return transactionHash;
};

export const approveUserOperation = async (AaHandler: AaHandler) => {
  const contract = getFrontDPContract();

  const approveCallData = getApproveCalldata(
    contract,
    env.NEXT_PUBLIC_PAY_MASTER_ADDRESS,
    10000,
  );

  console.log("approveCallData: ", approveCallData);

  const transactionHash = await AaHandler.sendUserOperation(
    [env.NEXT_PUBLIC_DP_TOKEN_ADDRESS],
    [approveCallData],
  );

  return transactionHash;
};

export const sendUserOperationEth = async (
  AaHandler: AaHandler,
  to: string,
  value: bigint,
) => {
  const transactionHash = await AaHandler.sendUserOperationEth(to, value);

  return transactionHash;
};
